const MessageType = Object.freeze({
  Error: 1,
  Success: 4,
  Warning: 5,
  None: -1
});

export default MessageType;
